/**
 * the key to be used for accessing search related storage objects
 */
export const SEARCH_PATH_LOCAL_STORAGE_KEY = 'lms.caseSearch';
